import AuthEmailVerificationPage from "common/auth/guard/email-verification";
import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import { Auth2FARequiredPage } from "./2fa-required-page";

export const AuthGuardProvider = ({ children }: PropsWithChildren<{}>) => {
  const emailVerificationStatus = useAppSelector(
    authNewSelectors.teamEmailVerificationStatusGet,
  );
  const location = useLocation();
  const userSession = useAppSelector(authNewSelectors.userSessionGet);

  if (userSession?.auth2FAStatus === "REQUIRED") {
    return <Auth2FARequiredPage />;
  }

  if (
    emailVerificationStatus === "REQUIRED" &&
    !location.pathname.startsWith(paths.emailVerify())
  ) {
    return <AuthEmailVerificationPage />;
  }

  return children;
};
